import React from 'react';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface ActionButtonProps {
  id?: string;
  to: string;
  onClick?(): void;
  icon?: IconDefinition;
}

/**
 * @author Jungwirth
 */
export const ActionButton: React.FC<ActionButtonProps> = (props: Readonly<ActionButtonProps>): JSX.Element => {
  const { to, id, icon, onClick } = props;

  return (
    <Button className="ml-2" tag={Link} to={to} onClick={onClick}>
      {icon && (<FontAwesomeIcon icon={icon} />) }
      {id && (<FormattedMessage id={id} />) }
    </Button>
  );
};
